// import Icon from '@ant-design/icons';
import React, { useState, useEffect } from "react";
import { Spin, message } from "antd";
import { LoadingOutlined, HomeOutlined } from "@ant-design/icons";
import { Row, Col } from "antd";
import liracrypt from "../../Liracrypt/liracrypt";
import SessionError from "../../ApiErrorComp/SessionError";
import ApiErrorComp from "../../ApiErrorComp/ApiErrorComp";
// import digitalFactoryLogo from "../../../images/DigitalFactory.png";
// import { Link } from "react-router-dom";
import AngelaIconMultiR1C from "../Common/Angela/AngelaIconMultiR1C";
import ZenVerBarChart from "../Common/Graph/ZenVerBarChart";
import ZenPieBar from "../Common/Graph/ZenPieBar";
import ZenDonut from "../Common/Graph/ZenDonut";
import ZenVerStackBar from "../Common/Graph/ZenVerStackBar";
import AngelaIcon1R from "../Common/Angela/AngelaIcon1R";

// Houdini_ImportData

const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

// const boxShadow = "5px 5px 14px #181818,-5px -5px 14px #343434";

class YiplCarlineDash extends React.Component {
  state = {
    mainData: null,
    loading: true,
    loginError: false,
    selectedTab: null,
    lid: "all",
    tabsData: null,
    selectedMnt: "all",
    table: null,
    Angela_PlantSummary: null,
    ZenVerBarChart_LinewiseDist: null,
    ZenPieBar_CustCarline: null,
    ZenDonut_PlantInpManHrs: null,
    ZenVerStackBar_InpManHrsCustomer: null,
    ZenVerStackBar_InpManHrsCarline: null,
    AngelaIcon1R_SingleCol: null,
    dataLoading: false,
    // Houdini_nullData
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }

 
  componentDidMount() {
    this.props.setPageHeader("Houdini Test Header");
    this._isMounted = true;
    this.fetchChartData();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }

  fetchChartData = (selectedTab= "all", lid = "all", mnt = "all") => {
    liracrypt
      .get("/chart/charyiplcarlinedash", {
        lid,
        mnt,
        typ: "MainGraph",
        subTyp: selectedTab,
        chartGroup: "YiplCarlineDash",
      })
      .then(({ data }) => {
        const resp = { ...data };
        let respData = {};

        respData["Angela_PlantSummary"] = resp["data"]["Angela_PlantSummary"];
        respData["ZenVerBarChart_LinewiseDist"] =
          resp["data"]["ZenVerBarChart_LinewiseDist"];
        respData["ZenPieBar_CustCarline"] =
          resp["data"]["ZenPieBar_CustCarline"];
        respData["ZenDonut_PlantInpManHrs"] =
          resp["data"]["ZenDonut_PlantInpManHrs"];
        respData["ZenVerStackBar_InpManHrsCustomer"] =
          resp["data"]["ZenVerStackBar_InpManHrsCustomer"];
        respData["ZenVerStackBar_InpManHrsCarline"] =
          resp["data"]["ZenVerStackBar_InpManHrsCarline"];
        respData["AngelaIcon1R_SingleCol"] =
          resp["data"]["AngelaIcon1R_SingleCol"];

        // Houdini_RespData

        respData["mainData"] = { ...resp };
        this._isMounted &&
          this.setState(
            {
              ...this.state,
              ...respData,
              loading: false,
              dataLoading: false,
            },
            () => {
              // console.log(this.state.dailyTrend);
            }
          );
      })
      .catch((error) => {
        // message.error('ERROR: Unable to save!', 4);
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            this.setState({
              ...this.state,
              loginError: true,
            });
          }
        }
      });
  };


  render() {
    if (this.state.mainData) {
      return (
        <>
          <SessionError visible={this.state.loginError} />
          <div
            style={{
              background: "#000000",
              paddingTop: 10,
              //   backgroundImage:
              //     "radial-gradient(circle, rgba(98,46,43,1) 0%, rgba(43,36,46,1) 50%, rgba(26,29,36,1) 100%)",
            }}
          >
           
            {this.state.loading === false ? (
              <div>
                <Col span={24}>
                  {this.state.mainData ? (
                    <div
                      style={{
                        margin: "10px",
                        padding: "10px",
                      }}
                    >
                      <div
                        style={{
                          color: "#bdc3c7",
                          fontSize: 28,
                          fontWeight: 400,
                          textAlign: "center",
                          margin: "0px 0px 30px 0px",
                        }}
                      >
                       Input Output Manhours Distribution
                      </div>

                      {/* ____________________________________START __________FORMAT________________TEMPLATE___________________*/}

                      <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "20%" }}></Col>
                        <Col style={{ width: "20%" }}></Col>
                        <Col style={{ width: "20%" }}></Col>
                        <Col style={{ width: "20%" }}></Col>
                      </Row>

                      {/* _______Row No 1________ */}
                      <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "20%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <AngelaIconMultiR1C
                              divId={"Angela_PlantSummary"}
                              data={this.state.Angela_PlantSummary.data}
                              config={this.state.Angela_PlantSummary.config}
                              // onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <AngelaIcon1R
                              divId={"AngelaIcon1R_SingleCol"}
                              data={this.state.AngelaIcon1R_SingleCol.data}
                              config={this.state.AngelaIcon1R_SingleCol.config}
                              // onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "40%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <ZenVerBarChart
                              divId={"ZenVerBarChart_LinewiseDist"}
                              data={this.state.ZenVerBarChart_LinewiseDist.data}
                              config={
                                this.state.ZenVerBarChart_LinewiseDist.config
                              }
                              // onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "40%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <ZenPieBar
                              divId={"ZenPieBar_CustCarline"}
                              data={this.state.ZenPieBar_CustCarline.data}
                              config={this.state.ZenPieBar_CustCarline.config}
                              // onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>
                      </Row>
                      {/* _______Row No 2________ */}
                      <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "20%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <ZenDonut
                              divId={"ZenDonut_PlantInpManHrs"}
                              data={this.state.ZenDonut_PlantInpManHrs.data}
                              config={this.state.ZenDonut_PlantInpManHrs.config}
                              // onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "40%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <ZenVerStackBar
                              divId={"ZenVerStackBar_InpManHrsCustomer"}
                              data={
                                this.state.ZenVerStackBar_InpManHrsCustomer.data
                              }
                              config={
                                this.state.ZenVerStackBar_InpManHrsCustomer
                                  .config
                              }
                              // onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "40%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <ZenVerStackBar
                              divId={"ZenVerStackBar_InpManHrsCarline"}
                              data={
                                this.state.ZenVerStackBar_InpManHrsCarline.data
                              }
                              config={
                                this.state.ZenVerStackBar_InpManHrsCarline
                                  .config
                              }
                              // onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>
                      </Row>
                      {/* _______Row No 3________ */}
                      <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "20%" }}>
                         
                        </Col>
                      </Row>

                      {/* Houdini_DivData */}
                    </div>
                  ) : null}
                </Col>
              </div>
            ) : (
              <div className="Loading" style={{ minHeight: "100vh" }}>
                <Spin indicator={antIcon} />
              </div>
            )}
          </div>
        </>
      );
    } else {
      return (
        <>
          {" "}
          <SessionError visible={this.state.loginError} />
          <div className="contentEmpty"></div>
        </>
      );
    }
  }
}

export default YiplCarlineDash;
